import React from "react";
import classes from "./index.module.css";
import Text from "../Text";
import { Close } from "@/components/Icons";
import { useTranslation } from "@/i18n/client";
import ActionIcon from "../ActionIcon";

interface HintProps {
  subHeading?: string;
  message: React.ReactElement | string;
  onClose?: () => void;
}

const Hint = ({ subHeading, message, onClose }: HintProps) => {
  const { t } = useTranslation("hints");
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Text variant="h5" c="neutral.7">
          {t("hint")}
        </Text>
        {onClose && (
          <ActionIcon size="sm" onClick={onClose}>
            <Close />
          </ActionIcon>
        )}
      </div>
      <div className={classes.content}>
        <Text variant="reading_medium_bold" c="neutral.7">
          {subHeading}
        </Text>
        <Text variant="reading_medium" c="neutral.7">
          {message}
        </Text>
      </div>
    </div>
  );
};

export default Hint;
